import { setLogCategory, logJsonAsFormatted, LogCategory, log } from './logger';

// increase this to easily see if our latest version is online
const CurVersion = "1.0.146";

const Suffixes = {
    licensingRoot : "/licensing/V1/",
    storeRoot : "/api/licenseApp/v1/"
};

const TestLocalSettings = {
    port: 3000,
    siteUrl: "http://mylicenseapp.maxvaluesoftware.com:3000/",
    licensingRoot: "http://apis_app_1" + Suffixes.licensingRoot,
    storeRoot: "http://store_app_1" + Suffixes.storeRoot,
    downloadRoot: "https://staging.holdemmanager.com/",
    isProduction: false,
    type: "local",

    logCategory: {
        startup: {name: "startup",log: true},
        info: {name: "info",log: false},
        warn: {name: "warn",log: false},
        error: {name: "ERROR",log: true},
        fatal: {name: "FATAL",log: true},
        initializeData: {name: "initialize",log: false},
        initialState: {name: "initialState",log: false},
        newUser: {name: "newUser",log: true},
        expires: {name: "expires",log: false},
        product: {name: "product",log: false},
        price: {name: "price",log: false},
        callback: {name: "callback",log: false},
        postInitialCall: {name: "postInitialCall",log: true},
        clientCall: {name: "clientCall",log: true},
        rawApiCallHeaders: {name: "rawApiCAllHeaders",log: true},
        rawApiCall: {name: "rawApiCall",log: false},
        rawApiPostBody: {name: "rawApiPostBody",log: true},
        rawApiCallAnswer: {name: "rawApiCallAnswer",log: false},
        restriction: {name: "restriction",log: false},
        purchase: {name: "purchase",log: true},
    },

    licensingToken: 'HM3-MLA-SERVER',
    // allow mocking the credit card info- for testing (have a dummy John Doe with some predefined info)
    mockCardInfo: true,

    mockCalls: true,
    
    simulateOverMaxVersion: false,

    // mock sending these exact license ids to store
    //mockStoreLicenseIds: [10],
    mockStoreLicenseIds: [],

    simulateStoreCalls: false,
    //simulateStoreCalls: true,
    simulateStorePaypalCall: { general: [ {message: "simulate: paypal error" } ]},
};


const TestLocalDockerSettings = {
    port: 86,
    siteUrl: "http://mylicenseapp.maxvaluesoftware.com:86/" ,
    licensingRoot: "http://apis_app_1" + Suffixes.licensingRoot,
    storeRoot: "http://store_app_1" + Suffixes.storeRoot,
    downloadRoot: "https://staging.holdemmanager.com/",
    isProduction: false,
    type: "local_docker",

    logCategory: {
        startup: {name: "startup",log: true},
        info: {name: "info",log: true},
        warn: {name: "warn",log: true},
        error: {name: "ERROR",log: true},
        fatal: {name: "FATAL",log: true},
        initializeData: {name: "initialize",log: false},
        initialState: {name: "initialState",log: false},
        newUser: {name: "newUser",log: true},
        expires: {name: "expires",log: false},
        product: {name: "product",log: false},
        price: {name: "price",log: false},
        callback: {name: "callback",log: false},
        postInitialCall: {name: "postInitialCall",log: true},
        clientCall: {name: "clientCall",log: true},
        rawApiCallHeaders: {name: "rawApiCAllHeaders",log: true},
        rawApiCall: {name: "rawApiCall",log: true},
        rawApiPostBody: {name: "rawApiPostBody",log: true},
        rawApiCallAnswer: {name: "rawApiCallAnswer",log: true},
        restriction: {name: "restriction",log: false},
        purchase: {name: "purchase",log: true},
    },
    
    licensingToken: 'HM3-MLA-SERVER',
    mockCardInfo: true,

    mockCalls: false,
    simulateOverMaxVersion: false,

    mockStoreLicenseIds: [],
    mockName: "",
    simulateStoreCalls: false,
};


const StagingSettings = {
    port: 80,
    siteUrl: "https://stagmla.maxvaluesoftware.com/",
    licensingRoot: "https://stagapi.maxvaluesoftware.com" + Suffixes.licensingRoot,
    storeRoot: "https://stagstore.holdemmanager.com" + Suffixes.storeRoot,
    downloadRoot: "https://staging.holdemmanager.com/",
    isProduction: false,
    type: "staging",

    logCategory: {
        startup: {name: "startup",log: true},
        info: {name: "info",log: false},
        warn: {name: "warn",log: false},
        error: {name: "ERROR",log: true},
        fatal: {name: "FATAL",log: true},
        initializeData: {name: "initialize",log: true},
        initialState: {name: "initialState",log: false},
        newUser: {name: "newUser",log: true},
        expires: {name: "expires",log: false},
        product: {name: "product",log: false},
        price: {name: "price",log: false},
        callback: {name: "callback",log: false},
        postInitialCall: {name: "postInitialCall",log: false},
        clientCall: {name: "clientCall",log: false},
        rawApiCallHeaders: {name: "rawApiCAllHeaders",log: false},
        rawApiCall: {name: "rawApiCall",log: false},
        rawApiPostBody: {name: "rawApiPostBody",log: false},
        rawApiCallAnswer: {name: "rawApiCallAnswer",log: false},
        restriction: {name: "restriction",log: false},
        purchase: {name: "purchase",log: false},
    },


    licensingToken: 'HM3-MLA-SERVER',
    mockCardInfo: false,

    mockCalls: false,
    simulateOverMaxVersion: false,

    mockStoreLicenseIds: [],
    mockName: "",
    simulateStoreCalls: false,
};


//live (production)
const ProductionSettings = {
    port: 80,
    siteUrl: "https://mylicenseapp.maxvaluesoftware.com/",
    licensingRoot: "https://api.maxvaluesoftware.com" + Suffixes.licensingRoot,
    storeRoot: "https://store.holdemmanager.com" + Suffixes.storeRoot,
    downloadRoot: "https://www.holdemmanager.com/",
    isProduction: true,
    type: "production",

    logCategory: {
        startup: {name: "startup",log: true},
        info: {name: "info",log: false},
        warn: {name: "warn",log: false},
        error: {name: "ERROR",log: true},
        fatal: {name: "FATAL",log: true},

        initializeData: {name: "initialize",log: true},

        initialState: {name: "initialState",log: false},
        newUser: {name: "newUser",log: false},
        expires: {name: "expires",log: false},
        product: {name: "product",log: false},
        price: {name: "price",log: false},
        callback: {name: "callback",log: false},
        postInitialCall: {name: "postInitialCall",log: false},
        clientCall: {name: "clientCall",log: false},
        rawApiCallHeaders: {name: "rawApiCAllHeaders",log: false},
        rawApiCall: {name: "rawApiCall",log: false},
        rawApiPostBody: {name: "rawApiPostBody",log: false},
        rawApiCallAnswer: {name: "rawApiCallAnswer",log: false},
        restriction: {name: "restriction",log: false},
        purchase: {name: "purchase",log: true},
    },

    licensingToken: 'HM3-MLA-SERVER',
    mockCardInfo: false,

    mockCalls: false,
    simulateOverMaxVersion: false,

    mockStoreLicenseIds: [],
    mockName: "",
    simulateStoreCalls: false,
};


var _settingsAlreadySet = false;
export var Settings = ProductionSettings;

export const updateSettingsFromUrl = url => {
    if ( _settingsAlreadySet )
        return;
    _settingsAlreadySet = true;
    let isLocal = false;

    var from = ProductionSettings;
    if ( url.indexOf("localhost") >= 0 ) {
        from = TestLocalSettings;
        isLocal = true;
    }
    if (url.indexOf("mylicenseapp.maxvaluesoftware.com:86") >= 0) {
        from = TestLocalDockerSettings;
        isLocal = true;
    }
    if ( url.indexOf("stagmla.") >= 0)
        from = StagingSettings;

    Settings = from;
    setLogCategory( Settings.logCategory);
    logJsonAsFormatted(isLocal) ;
    log(LogCategory.info, "initializing settings from url " + url + " at version " + CurVersion + " => " + JSON.stringify(Settings));
    log(LogCategory.startup, "starting up " + CurVersion);
};

export const urlIsProduction = url => {
    var isProduction = true;
    if ( url.indexOf("localhost") >= 0 ) {
        isProduction = false;
    }
    if (url.indexOf("mylicenseapp.maxvaluesoftware.com:86") >= 0) {
        isProduction = false;
    }
    if ( url.indexOf("stagmla.") >= 0)
        isProduction = false;

    return isProduction;
};



// WEBPACK FOOTER //
// ./src/api/settings.js